import React from 'react';

export default function Header() {
  return (
    <header className="bg-transparent py-4">
      <div className="container flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div>
            <div className="text-sm font-medium">Faizur Rahman</div>
            <div className="text-xs text-gray-500">IV A — MEASI Matriculation HSS</div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <nav className="hidden md:flex items-center gap-4 text-sm text-gray-700">
            <span className="opacity-80">Interactive Map</span>
            <a className="text-sm text-gray-500">About</a>
          </nav>

          <img
            src="/images/faizur.jpeg"
            alt="Faizur"
            className="w-10 h-10 rounded-full object-cover ring-1 ring-gray-200 shadow-sm"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        </div>
      </div>
    </header>
  );
}
